package features.uploadReceipt.models

import kangaroorewards.appsdk.core.io.Model
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport

@ExperimentalJsExport
@JsExport
@Serializable
data class UploadReceiptResponseModel(
    @SerialName("id")
    val id: Int,

    @SerialName("status")
    val status: String,

    @SerialName("rejection_message")
    val rejectionMessage: String?,

    @SerialName("transaction")
    val transaction: Transaction?
) : Model()